import { useCallback, useState } from 'react';
import { parseError } from '@/utils';
import { DormitoryLegacyHttp } from '@/services';

export default function useDormitoryRoomMembers() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [members, setMembers] = useState<DormitoryRoomMember[]>([]);

  const fetchDormitoryRoomMembers = useCallback(async (
    dormitoryId: number,
    blockId: number,
    floorId: number,
    roomId: number
  ) => {
    try {
      setLoading(true);
      const res = await DormitoryLegacyHttp.fetchDormitoryRoomMembers(dormitoryId, blockId, floorId, roomId);
      setMembers(res.payload?.eskanDatas ?? []);
    }
    catch (e) {
      setError(parseError(e));
    }
    finally {
      setLoading(false);
    }
  }, []);

  return { members, fetchDormitoryRoomMembers, loading, error };
}
